import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CardsSection from '@/pages/home/components/CardsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FaqSection from '@/pages/home/components/FaqSection';
import ContactSection from '@/pages/home/components/ContactSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import IndexSection from '@/pages/home/components/IndexSection';
import MediaSection from '@/pages/home/components/MediaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 font-body">
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <FeaturesSection />
        <TopicsSection />
        <CarouselSection />
        <CardsSection />
        <UpdatesSection />
        <RankingSection />
        <FaqSection />
        <ContactSection />
        <AboutSection />
        <AppSection />
        <IndexSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}